<template>
    <div id="editAdminbuss" class="app-inner">
         <div class="public-btn-small flex align-cen" style="padding-left:0;margin-bottom:16px">
            <div class="public-btn-small-plan"  @click="reback" style="margin-left:0">
                返回
            </div>
             <el-button type="primary" :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
            @click="onSubmit('ruleForm')"
            >
                {{edittext}}
            </el-button>
            </div>
        <div class="edit-from">
             <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
         <el-form ref="ruleForm" :model="form" label-width="120px" :rules="rules" class="flex align-cen">
               <el-form-item label="管理员姓名：" prop="userName">
                    <el-input v-model="form.userName" placeholder="请输入管理员姓名【0-30】" clearable></el-input>
                </el-form-item>
                 <el-form-item label="管理员账号：" prop="loginName">
                    <el-input v-model="form.loginName" placeholder="请输入管理员手机号" clearable></el-input>
                </el-form-item>
                 <el-form-item label="账号密码：" prop="password">
                    <el-input v-model="form.password" :placeholder="placeholder" show-password clearable></el-input>
                </el-form-item>
         </el-form>
        </div>
    </div>
</template>
<script>
import  Format from "../../../utils/auth.js"  
import { businessAccountDetail } from "@/api/index/index" //详情
import { editAccount } from "@/api/index/index" //保存修改
export default {
    name:'EditAdminbuss',
    data: () => {
        return {
            loading:false,
            edittext:'保存',
            form:{
            userName:'',
            loginName:'',
            password:''
            },
            placeholder:'请输入管理员账号密码，若未输入则为123456',
                rules:{
              userName: [
                     {
                        validator: Format.FormValidate.Form().APPName,   //validator： 自定义验证规则
                        trigger: "blur",
                        message:'请正确输入符合规则的企业名称',
                        required: true, 
                        }
                 ],
              loginName: [{ required: true, message: '请输入管理员账号', trigger: 'blur' },],
        },
        }
    },
    created(){
         if(this.$route.query.id){
            this.$route.meta.title = "修改企业信息"
            this.edittext = "修改"
             this.placeholder = '密码不便展示，若想修改，直接输入新密码提交即可'
            this.getDetail()
        }else{
            this.$route.meta.title = "新增企业" 
             this.placeholder = '请输入管理员账号密码，若未输入则为123456'
             this.edittext = "保存"
        }
    },
    methods: {
             // 获取企业管理员详情
        getDetail(){
              businessAccountDetail({
                id:this.$route.query.id
              })
            .then(res => {
             this.form = {
                    userName:res.data.userName,
                    loginName:res.data.loginName,
                    password:res.data.password
                }
            })
            .catch(err => {
            })
        },
        // 返回
        reback(){
        this.$router.back()
        },
              onSubmit(formName){
		            let params;
                    let method = "post"
                     if(!this.$route.query.id) params = {...this.form},method = "post"; 
                     if(this.$route.query.id) params = {...this.form,id:this.$route.query.id}, method = "put"; 
                    this.$refs[formName].validate((valid) => {
                        if(valid){
                            this.commentBness(params,method)
                        }
                    })
        },
        commentBness(params,method){
             this.loading = true
                editAccount(params,method)
                        .then(res => {
                            this.loading = false
                           if(res.code == 0){
                            if(!this.$route.query.id) this.$message.success('新增成功'); 
                           if(this.$route.query.id) this.$message.success('修改成功'); 
                                setTimeout(() => {
                           this.$router.push("/businessAdmin")
                             }, 100);
                           }else{
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                            this.loading = false
                        })
        },
    }
}
</script>
<style lang="scss" scoped>
 .edit-from{
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
         .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        }
         }

    }
</style>